import axios from 'axios'

export default {
  baseUrl: 'https://dreamhoneymoon.com/wp-json/',
  get(endpoint) {
    return axios({
      method: 'get',
      url: this.baseUrl+endpoint
    });
  },
  post(endpoint, data, headers) {
    return axios({
      method: 'post',
      url: this.baseUrl+endpoint,
      data: data,
      headers: headers
    });
  }
};